import { List, Map } from 'immutable';

import * as types from './types';
import * as functions from './functions';
import {
  FILTER_AUTOMATED_BUILDS,
  FILTER_AUTOMATED_TESTS,
  FILTER_HEADLESS_BUILDS,
  FILTER_HEADLESS_TESTS,
  FILTER_TYPE_STATUS,
  FILTER_TYPE_OWNERSHIP,
  FILTER_TYPE_PERFORMANCE,
  PERFORMANCE_DEFAULT,
} from './constants';

const initialState = Map({
  filtersInitialized: false,
  orgTeams: List(),
  orgUsers: List(),
  username: null,
  [FILTER_AUTOMATED_BUILDS]: Map({
    [FILTER_TYPE_STATUS]: List(),
    [FILTER_TYPE_OWNERSHIP]: Map(),
  }),
  [FILTER_AUTOMATED_TESTS]: Map({
    [FILTER_TYPE_STATUS]: List(),
    [FILTER_TYPE_OWNERSHIP]: Map(),
    [FILTER_TYPE_PERFORMANCE]: PERFORMANCE_DEFAULT,
  }),
  [FILTER_HEADLESS_BUILDS]: Map({
    [FILTER_TYPE_STATUS]: List(),
    [FILTER_TYPE_OWNERSHIP]: Map(),
  }),
  [FILTER_HEADLESS_TESTS]: Map({
    [FILTER_TYPE_STATUS]: List(),
    [FILTER_TYPE_OWNERSHIP]: Map(),
  }),
});

const filtersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.INITIALIZE_FILTERS:
      return state.set('filtersInitialized', true);
    case types.GET_ORG_USERS.SUCCESS:
      return state.set('orgUsers', List(payload.users));
    case types.TEAMLIST_GET.SUCCESS:
      return state.set('orgTeams', List(payload.results));
    case types.RESET_FILTERS:
      return initialState.set('username', payload.username);
    case types.TOGGLE_STATUS: {
      const index = state.getIn([payload.type, FILTER_TYPE_STATUS]).indexOf(payload.data);
      const updatedFilters = index === -1 ?
        state.updateIn([payload.type, FILTER_TYPE_STATUS], (status) => status.push(payload.data)) :
        state.updateIn([payload.type, FILTER_TYPE_STATUS], (status) => status.delete(index));
      return updatedFilters;
    }
    case types.CLEAR_STATUSES: {
      const updatedFilters = state.setIn(
        [payload.type, FILTER_TYPE_STATUS],
        initialState.getIn([payload.type, FILTER_TYPE_STATUS]),
      );
      return updatedFilters;
    }
    case types.SELECT_OWNER: {
      const updatedFilters = state.setIn(
        [payload.type, FILTER_TYPE_OWNERSHIP],
        Map(payload.data),
      );
      return updatedFilters;
    }
    case types.UPDATE_FILTERS_FROM_LS: {
      const updatedFilters = initialState.merge(
        functions.deserializeFiltersFromLS(JSON.parse(payload.filters)),
      );
      return updatedFilters;
    }
    case types.CLEAR_OWNER: {
      const updatedFilters = state.setIn(
        [payload.type, FILTER_TYPE_OWNERSHIP],
        initialState.getIn([payload.type, FILTER_TYPE_OWNERSHIP]),
      );
      return updatedFilters;
    }
    case types.TOGGLE_PERFORMANCE: {
      const updatedFilters = state.setIn(
        [FILTER_AUTOMATED_TESTS, FILTER_TYPE_PERFORMANCE],
        payload,
      );
      return updatedFilters;
    }
    default:
      return state;
  }
};

export default filtersReducer;
export { initialState };
